"use client";

import { useEffect } from "react";
import ErrorPage from "@/components/entities/error";
import { useTranslations } from "next-intl";

export default function Error({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  const t = useTranslations();

  useEffect(() => {
    console.error(error);
  }, [error]);

  return <ErrorPage title={t("error.wrong")} text={error.message} />;
}
